import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';

// createContext() 호출 시 초기값을 null 또는 undefined 대신 객체 형태로 제공하면
// Provider가 없을 때 발생하는 오류를 방지하고 디버깅에 용이할 수 있습니다.
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');

  // theme 상태가 변경될 때마다 html 문서의 class를 변경합니다.
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  // 매번 새로운 객체가 생성되는 것을 방지하기 위해 useMemo를 사용합니다.
  const value = useMemo(() => ({ theme, setTheme }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

// 커스텀 훅
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        // Provider가 없는 경우 에러를 발생시켜 문제를 빠르게 인지하도록 합니다.
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};